import { Component, OnInit } from '@angular/core';
import { IonUtilititesService } from '../../services/ion-utilities/ion-utilitites.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent implements OnInit {

  items = [
    "Our chats are end to end encrypted to maintain users privacy which secures it from falling into wrong hands.",
    "Location: MakeShaadi does not track your location, however, we do collect it once after you log into your account for analytical purposes.",
    "We take security measures to help safeguard your personal information from unauthorised access and disclosure. However no system is completely secure, we do not promise that your personal information, chats or other communication will always remain safe; users should always take care with how they handle and disclose their personal information.",
    "We may share your information with third parties that perform certain services on our behalf. These service providers may have access to personal information needed to perform their functions but are not permitted to share or use such information for any other purpose.",
    "When you use the application, the company collects server logs which may include information such as IP addresses, operating system or application crashes.",
  ]

  constructor(private _ion: IonUtilititesService) { }

  ngOnInit() { }

  close() {
    this._ion.modalController.dismiss();
  }
}
